import store from '../store';

export default {
  getAuctions() {
    return store.dispatch('Data/Auctions/getAuctions');
  },
  getAuctionsLots() {
    return store.dispatch('Data/Auctions/getAuctionsLots');
  },
  getAuctionsLotsDetails() {
    return store.dispatch('Data/Auctions/getAuctionsLotsDetails');
  },
  getAuctionsBids() {
    return store.dispatch('Data/Auctions/getAuctionsBids');
  },
  getAuctionDetails() {
    return store.dispatch('Data/Auctions/getAuctionDetails');
  },
  setAuction(payload) {
    return store.dispatch('Data/Auctions/setAuction', payload);
  },
};
